/*
 * @Description:
 * @Version: 2.0
 * @Autor: lijunyan
 * @Date: 2021-06-25 22:20:44
 * @LastEditors: lijunyan
 * @LastEditTime: 2021-06-25 22:23:00
 */
export let rules = {
  code: [{ required: true, message: '请填写入库单编号', trigger: 'blur' }],
  rebarGrade: [{ required: true, message: '请填写原料级别', trigger: 'blur' }],
}
